import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'

import './static/css/main.scss'

//在项目入口文件 main.js 引入离线icon文件
import './static/iconfont/iconfont.css'

import App from './App.vue'
import router from './router'
import scrollObserver from './directives/scrollObserver'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(ElementPlus, {
  locale: zhCn,
})

app.directive('scrollObserver', scrollObserver)

app.mount('#app')
